import type { TopBondPicksActions } from "./types";

export const fetchAllTopBondPicks = (): TopBondPicksActions => ({
  type: "REQUEST_TOP_BOND_PICKS_DATA",
});

export const fetchAllTopBondPicksSuccess = (payload): TopBondPicksActions => ({
  type: "REQUEST_TOP_BOND_PICKS_SUCCESS",
  payload,
});

export const fetchAllTopBondPicksError = (): TopBondPicksActions => ({
  type: "REQUEST_TOP_BOND_PICKS_FAILED",
});
